export default "__VITE_ASSET__CmT0QLE4__"